import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { MemberType } from '@eastcoal/shared/enums/MemberType'

import { AuditViewButtonProps } from './interface'

export const AuditViewButton = ({
  record: { id, type, managerId }
}: AuditViewButtonProps) => {
  const memberType = type === MemberType.PERSON ? 'person' : 'enterprise'
  const to = stringifyUrl({
    url: `/audit/${memberType}/detail`,
    query: {
      memberId: id,
      managerId
    }
  })

  return <NavigateButton to={to}>查看认证</NavigateButton>
}
